import React from 'react';
import { getApiCurrentLanguage, getCurrentLanguage, translate } from '../../assets/js/functions';
import parse from 'html-react-parser';
import './assets/scss/styles.scss'
import { Container, Row, Col } from 'react-bootstrap';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';

export default function Expositions() {
  return (
    <div id='expositions'>
        <Breadcrumbs currentSite={translate('Exposiciones')}/>
        <div className="expositions-list">
            <Container>
                <Row>
                    <Col xs={12} md={3}  className="theme-item project-item">
                        <a href={`https://oroibidea.es/maria-luisa-elio/${['es', 'eu'].includes(getCurrentLanguage()) ? getCurrentLanguage() : ''}`} target="_blank" rel="noreferrer" className="btn-cmn">
                            <span>
                                {parse(translate("Regresar es irse. María Luisa Elío y la herida del exilio"))}
                            </span>
                            {getCurrentLanguage() == 'en' || getCurrentLanguage() == 'fr'
                                ? <><small>{translate('Solo en español')}</small></>
                                : ''
                            }
                        </a>
                    </Col>
                    <Col xs={12} md={3}  className="theme-item project-item">
                        <a href={`https://oroibidea.es/carmen-huder/${['es', 'eu'].includes(getCurrentLanguage()) ? getCurrentLanguage() : ''}`} target="_blank" rel="noreferrer" className="btn-cmn">
                            <span>
                                {parse(translate("Carmen Húder Carlosena, una mujer del 27"))}
                            </span>
                            {getCurrentLanguage() == 'en' || getCurrentLanguage() == 'fr'
                                ? <><small>{translate('Solo en español')}</small></>
                                : ''
                            }
                        </a>
                    </Col>
                    <Col xs={12} md={3}  className="theme-item project-item">
                        <a href={`https://oroibidea.es/boomerang/${['es', 'eu'].includes(getCurrentLanguage()) ? '?lang=' + getCurrentLanguage() : ''}`} target="_blank" rel="noreferrer" className="btn-cmn">
                            <span>
                                {parse(translate("Operación Boomerang"))}
                            </span>
                            {getCurrentLanguage() == 'en' || getCurrentLanguage() == 'fr'
                                ? <><small>{translate('Solo en español')}</small></>
                                : ''
                            }
                        </a>
                    </Col>
                    <Col xs={12} md={3}  className="theme-item project-item">
                        <a href={`https://oroibidea.es/simbologia/${['es', 'eu'].includes(getCurrentLanguage()) ? getCurrentLanguage() : 'es'}`} target="_blank" rel="noreferrer" className="btn-cmn">
                            <span>
                                {parse(translate("Símbolos de un tiempo"))}
                            </span>
                            {getCurrentLanguage() == 'en' || getCurrentLanguage() == 'fr'
                                ? <><small>{translate('Solo en español')}</small></>
                                : ''
                            }
                        </a>
                    </Col>
                    <Col xs={12} md={3}  className="theme-item project-item">
                        <a href={`https://oroibidea.es/mujerymemoria/${['es', 'eu'].includes(getCurrentLanguage()) ? getCurrentLanguage() : 'es'}`} target="_blank" rel="noreferrer" className="btn-cmn">
                            <span>
                                {parse(translate("Mujer y memoria"))}
                            </span>
                            {getCurrentLanguage() == 'en' || getCurrentLanguage() == 'fr'
                                ? <><small>{translate('Solo en español')}</small></>
                                : ''
                            }
                        </a>
                    </Col>
                    <Col xs={12} md={3}  className="theme-item project-item">
                        <a href={`https://oroibidea.es/maestros/${['es', 'eu'].includes(getCurrentLanguage()) ? getCurrentLanguage() : 'es'}`} target="_blank" rel="noreferrer" className="btn-cmn">
                            <span>
                                {parse(translate("Maestras y maestros <br/> represaliados en Navarra (1936-1976)"))}
                            </span>
                            {getCurrentLanguage() == 'en' || getCurrentLanguage() == 'fr'
                                ? <><small>{translate('Solo en español')}</small></>
                                : ''
                            }
                        </a>
                    </Col>
                    <Col xs={12} md={3}  className="theme-item project-item">
                        <a href={"https://oroibidea.es/cautividad/"+(getCurrentLanguage() !== 'es' ? getCurrentLanguage() : '')} target="_blank" rel="noreferrer" className="btn-cmn"><span>
                                {parse(translate("La ciudad de los cautivos <br/> Centros de detención en Pamplona, 1936-1945")) }
                            </span>
                            {getCurrentLanguage() == 'en' || getCurrentLanguage() == 'fr'?
                            <><small>{translate('Solo en español')}</small></>
                            :
                            ''}
                        </a>
                    </Col>
                    <Col xs={12} md={3}  className="theme-item project-item">
                        <a href={"https://navarraobjecioninsumision.navarra.es/"+getCurrentLanguage()} target="_blank" rel="noreferrer" className="btn-cmn"><span>
                                {parse(translate("Memorias de la objeción <br/> y la insumisión en navarra")) }
                            </span>
                            {getCurrentLanguage() == 'en' || getCurrentLanguage() == 'fr'?
                            <><small>{translate('Solo en español')}</small></>
                            :
                            ''}
                        </a>
                    </Col>
                    <Col xs={12} md={3}  className="theme-item project-item">
                        <a href={"https://exhumacionestempranas.navarra.es/?lang=lg-"+getApiCurrentLanguage()} target="_blank" rel="noreferrer" className="btn-cmn"><span>
                                {parse(translate("Bajo tierra <br/> exhumaciones tempranas en navarra")) }
                            </span>
                            {getCurrentLanguage() == 'en' || getCurrentLanguage() == 'fr'?
                            <><small>{translate('Solo en español')}</small></>
                            :
                            ''}
                        </a>
                    </Col>
                </Row>
            </Container>
        </div>
    </div>
    );
}
